import template from './synonym-api-list.html.twig';
import '../../component/synonym-api-form';

const { Component, Mixin } = Shopware;
const { Criteria } = Shopware.Data;

Component.register('topdata-es-synonym-api-list', {
    template,

    inject: ['repositoryFactory'],

    mixins: [
        Mixin.getByName('listing'),
        Mixin.getByName('notification'),
    ],

    data() {
        return {
            items: null,
            isLoading: true,
            sortBy: 'position',
            sortDirection: 'ASC',
            limit: 25,
            activeModal: false,
            currentEntity: null,
            showDeleteModal: false,
            itemToDelete: null,
        };
    },

    computed: {
        deleteConfirmText() {
            if (!this.itemToDelete) return '';
            return this.$t('TopdataEnhancedSearchSW6.topdata-es-synonym-api.deleteConfirmText', {
                name: this.itemToDelete.name,
            });
        },

        repository() {
            return this.repositoryFactory.create('tdes_synonym_api');
        },

        columns() {
            return [{
                property: 'name',
                label: this.$tc('TopdataEnhancedSearchSW6.topdata-es-synonym-api.columnName'),
                allowResize: true,
                primary: true,
                sortable: true,
            }, {
                property: 'url',
                label: this.$tc('TopdataEnhancedSearchSW6.topdata-es-synonym-api.columnUrl'),
                allowResize: true,
                sortable: false,
            }, {
                property: 'language',
                label: this.$tc('TopdataEnhancedSearchSW6.topdata-es-synonym-api.columnLanguage'),
                allowResize: true,
                sortable: true,
            }, {
                property: 'active',
                label: this.$tc('TopdataEnhancedSearchSW6.topdata-es-synonym-api.columnActive'),
                allowResize: true,
                sortable: true,
            }, {
                property: 'position',
                label: this.$tc('TopdataEnhancedSearchSW6.topdata-es-synonym-api.columnPosition'),
                allowResize: true,
                sortable: true,
            }];
        },
    },

    mounted() {
        this.getList();
    },

    methods: {
        getList() {
            this.isLoading = true;

            const criteria = new Criteria(this.page, this.limit);
            criteria.addSorting(Criteria.sort(this.sortBy, this.sortDirection));

            this.repository.search(criteria).then((result) => {
                this.total = result.total;
                this.items = result;
                this.isLoading = false;
            }).catch(() => {
                this.isLoading = false;
            });
        },

        onPageChange(params) {
            this.page = params.page;
            this.limit = params.limit;
            this.getList();
        },

        onSortColumn(column) {
            this.sortBy = column.dataIndex ?? column.property;
            this.sortDirection = column.sortDirection ?? 'ASC';
            this.getList();
        },

        onAddApi() {
            this.currentEntity = this.repository.create();
            this.currentEntity.name = '';
            this.currentEntity.url = '';
            this.currentEntity.jsonPath = '';
            this.currentEntity.language = 'de';
            this.currentEntity.active = true;
            this.currentEntity.position = 0;
            this.activeModal = true;
        },

        onEditApi(item) {
            this.repository.get(item.id).then((entity) => {
                this.currentEntity = entity;
                this.activeModal = true;
            });
        },

        onCloseModal() {
            this.activeModal = false;
            this.currentEntity = null;
            this.getList();
        },

        onShowDeleteModal(item) {
            this.itemToDelete = item;
            this.showDeleteModal = true;
        },

        onCloseDeleteModal() {
            this.showDeleteModal = false;
            this.itemToDelete = null;
        },

        onConfirmDelete() {
            this.repository.delete(this.itemToDelete.id).then(() => {
                this.createNotificationSuccess({
                    message: this.$tc('TopdataEnhancedSearchSW6.topdata-es-synonym-api.deleteSuccess'),
                });
                this.onCloseDeleteModal();
                this.getList();
            }).catch(() => {
                this.onCloseDeleteModal();
            });
        },
    },
});